const styles = {
  titleSx: {
    fontSize: { xs: "1.6rem", sm: "1.9rem", md: "2.25rem" },
    color: "white",
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: "0.02em",
    m: 0,
    p: 0,
  },

  descriptionSx: {
    color: "rgba(255,255,255,0.38)",
    fontSize: { xs: "0.825rem", sm: "0.9rem", md: "0.95rem" },
    letterSpacing: "0.04em",
    p: 0,
    mt: "12px",
    mb: { xs: "32px", md: "52px" },
  },
};

export default styles;
